import React, { useMemo } from 'react'
import { Spin } from "antd";
import { BoxForm, Button, Input, Select } from "components";
import usePayment from "hooks/usePayment";
import * as S from "../styles"
import { useFormContext } from "react-hook-form";
import { ResponseGetDetrans } from "views/Partner/providers/dto/get-detrans.dto";
import { EnumState, GetAllDebitsRequest } from "views/Partner/providers/dto/get-debits.dto";
import { useGetDebitsManager } from "../hooks/useGetDebitsManager";
import { useWhitelabel } from "hooks";
import { useSearchParams } from "react-router-dom";

interface BoxFormDetranProps {
  handleShowLogoDetran: (state: string) => void;
  detrans: ResponseGetDetrans | undefined;
  isDisabled: boolean;
  isLoading: boolean;
  idEstablishment: string;
  setVariables: (variables: GetAllDebitsRequest) => void;
}

const BoxFormDetran = ({ handleShowLogoDetran, detrans, isDisabled, idEstablishment, setVariables, isLoading }: BoxFormDetranProps) => {
  const { control, handleSubmit, formState: { errors }, watch } = useFormContext()
  const { detran, dataPaymentBillet } = usePayment()
  const { client } = useWhitelabel()

  const [searchParams] = useSearchParams()

  const id_detran = searchParams.get("id_detran")
  const [license_plate] = watch(["license_plate"])

  const { mutate: getDebits, isLoading: isLoadingGetDebts } = useGetDebitsManager({ license_plate, isPublicDepartment: false, setVariablesRequest: setVariables })

  const fetchDebtsVehicle = async (data: { detran?: EnumState, license_plate?: string, renavam?: string, document?: string }) => {
    getDebits({
      id_establishment: idEstablishment,
      state: data.detran ?? detran.state,
      license_plate: data.license_plate,
      renavam: data.renavam,
      document: data.document?.replace(/\D/g, ""),
    });
  };

  const renderSelectBox = useMemo(() => {
    return client?.id_whitelabel && id_detran;
  }, [client?.id_whitelabel]);

  return (
    <BoxForm hide={!dataPaymentBillet?.debits.length}>
      <Spin spinning={false}>
        <S.WrapperBoxForm>
          <S.TitleForm>Informe os dados para consultarmos.</S.TitleForm>

          <S.WrapperImage disabled={!detran?.image_src}>
            <S.ImgDetran src={detran?.image_src} />
          </S.WrapperImage>

          {!renderSelectBox && <S.WrapperInput>
            <Select
              control={control}
              name="detran"
              error={errors?.detran?.message as string}
              onChange={(e) => handleShowLogoDetran(e.target.value)}
            >
              <S.Option value="" disabled selected>
                Detran
              </S.Option>
              {detrans?.data
                .filter((detran) => detran.integrated)
                .map((detran, index) => {
                  return (
                    <S.Option
                      key={index}
                      value={detran.state.toUpperCase()}
                    >
                      {`Detran ${detran.state}`}
                    </S.Option>
                  );
                })}
            </Select>
          </S.WrapperInput>}

          {detran?.fields?.map((field) => (
            <S.WrapperInput key={field.input_key}>
              <Input
                type="text"
                type_input="normal"
                placeholder={field.label}
                name={field.input_key.toLocaleLowerCase()}
                control={control}
                required={field.required}
                error={
                  errors[field.input_key.toLocaleLowerCase()]
                    ?.message as string
                }
              />
            </S.WrapperInput>
          ))}
          <S.WrapperButton>
            <S.Button>
              <Button
                title="Pesquisar"
                type_button="primary"
                loading={isLoadingGetDebts || isLoading}
                disabled={isDisabled || !!Object.keys(errors).length}
                action={handleSubmit(fetchDebtsVehicle)}
              />
            </S.Button>
          </S.WrapperButton>
        </S.WrapperBoxForm>
      </Spin>
    </BoxForm>
  )
}

export default BoxFormDetran